import type { RouteRecordRaw } from 'vue-router'

import { registerPlatformActionMessages } from './i18n'
import { CHANGE_DETAIL_ROUTE, PLATFORM_ACTIONS_ROUTE_NAME } from './routeNames'

import { useLocaleStore } from '@/shared/i18n'

export const PLATFORM_ACTIONS_ROUTE = { name: PLATFORM_ACTIONS_ROUTE_NAME } as const

export const platformActionRoutes: RouteRecordRaw[] = [
  {
    // Same `tools/` prefix as health checks, but URL-only: the nav leaf is top-level.
    path: 'tools/platform-actions',
    name: PLATFORM_ACTIONS_ROUTE.name,
    component: () => import('./components/PlatformActionsPage.vue'),
    meta: {
      requiresAuth: true,
      navKey: 'platformActions',
      titleKey: 'platformActions.page.title',
    },
    // No `permission` meta: the gate is the private `platform_actions` FLAG, and route meta has no
    // flag field. The page owns it (`usePlatformActionAccess`) and renders the disabled state, so a
    // deep link from a non-whitelisted workspace explains itself instead of bouncing to home.
    beforeEnter: () => registerPlatformActionMessages(useLocaleStore().locale),
  },
  {
    // One change, read-only — the inbox rows and the drawer link here (v3 `/approvals/:actionId`).
    path: 'tools/platform-actions/:actionId',
    name: CHANGE_DETAIL_ROUTE,
    component: () => import('./components/ChangeDetailPage.vue'),
    meta: {
      requiresAuth: true,
      navKey: 'platformActions',
      titleKey: 'platformActions.changeDetail.pageTitle',
    },
    beforeEnter: () => registerPlatformActionMessages(useLocaleStore().locale),
  },
]
